import Component from "@base/js/component";
import $ from "jquery";

export default class PerformanceRow extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".state-policy-data";

  // Defines children that needs to be queried as part of this component
  static children = {
    expandedContainer: ".state-policy-data__item-expanded-content",
    expandButton: ".state-policy-data__item-expand",
    tooltipIcons: [".state-policy-data__item-tooltip-icon"],
    policyContent: ".state-policy-data__content",
  };

  isTransitioning = false;

  // Defines event handlers to attach to children
  eventHandlers = {
    expandedContainer: {
      transitionstart: this.onExpandedRowTransitionStart,
      transitionend: this.onExpandedRowTransitionEnd,
    },
    tooltipIcons: {
      click: this.onTooltipClick,
    },
  };

  afterInit() {
    const { expandedContainer, expandButton } = this.children;
    const self = this;
    if (expandButton && expandedContainer) {
      // to make sure that dom is rendered to get exact render height
      setTimeout(() => {
        expandButton.addEventListener("click", (ev) => {
          ev.preventDefault();
          if (expandedContainer.classList.contains("content-expanded")) {
            self.hideRow(expandedContainer);
            $(expandButton).find("span.inner-text").text("Expand");
          } else {
            self.expandRow(expandedContainer);
            $(expandButton).find("span.inner-text").text("Collapse");
            const firstLinkOnExpand = expandedContainer.querySelector(
              ".state-policy-data__item-cta-link"
            );
            $(firstLinkOnExpand).trigger("focus");
          }
        });
        self.hideRow(expandedContainer);
      }, 250);

      $(".state-policy-data .state-policy-data__item-tooltip-icon").on(
        "keydown",
        (e) => {
          if (/^(13|32)$/.test(e.which)) {
            e.preventDefault();
            self.onTooltipClick(e, "click");
          }
        }
      );
    }

    // Add event listener to check if the user clicks outside the container
    $(document).on("click", (event) => {
      if (
        !$(event.target).closest(".state-policy-data__item-tooltip-wrapper")
          .length
      ) {
        if (
          $(".state-policy-data__item-tooltip-wrapper .show-tooltip").length > 0
        )
          $(
            ".state-policy-data__item-tooltip-wrapper .show-tooltip"
          ).removeClass("show-tooltip");
      }
    });
  }

  onExpandedRowTransitionStart(e) {
    if (e.target === e.currentTarget) {
      this.isTransitioning = true;
    }
  }

  onExpandedRowTransitionEnd(e) {
    if (e.target === e.currentTarget) {
      if (
        !this.children.expandedContainer.classList.contains("content-expanded")
      ) {
        this.children.expandedContainer.style.display = "none";
      }
    }
  }

  expandRow(expandedContainer) {
    expandedContainer.style.display = "block";
    expandedContainer.style.height = `unset`;
    const { height } = expandedContainer.getBoundingClientRect();
    expandedContainer.style.height = `${0}px`;
    setTimeout(() => {
      expandedContainer.style.height = `${height}px`;
      expandedContainer.classList.add("content-expanded");
    }, 100);
  }

  hideRow(expandedContainer) {
    const { height } = expandedContainer.getBoundingClientRect();
    expandedContainer.style.height = `${height}px`;
    setTimeout(() => {
      expandedContainer.style.height = `${0}px`;
      expandedContainer.classList.remove("content-expanded");
    }, 100);
  }

  updateRowHeightOnResize() {
    const { expandedContainer } = this.children;

    const totalExpandedHeight =
      expandedContainer.getBoundingClientRect().height;
    if (totalExpandedHeight > 0) {
      expandedContainer.setAttribute(
        "data-expanded-height",
        `${totalExpandedHeight}`
      );
      this.hideRow();
    }
  }

  onTooltipClick(ev) {
    const targetEl = ev.target;
    const sibling = targetEl.nextElementSibling;
    if (targetEl === ev.currentTarget && sibling) {
      targetEl.classList.toggle("show-tooltip");
      if (targetEl.classList.contains("show-tooltip")) {
        $(this.children.policyContent)
          .find(".show-tooltip")
          .each((i, el) => {
            if (el !== targetEl) {
              $(el).removeClass("show-tooltip");
            }
          });
        targetEl.classList.add("show-tooltip");
        sibling.style.display = "block";
        sibling.style.opacity = "0";
        $(sibling).attr("role", "");
        setTimeout(() => {
          sibling.style.opacity = "1";
          sibling.style.display = "";
          $(sibling).attr("role", "alert");
        }, 100);
      }
    }
  }

  showTooltip(ev) {
    const targetEl = ev.target;
    const sibling = targetEl.nextElementSibling;
    if (targetEl === ev.currentTarget && sibling) {
      targetEl.classList.add("show-tooltip");
      if (targetEl.classList.contains("show-tooltip")) {
        sibling.style.display = "block";
        sibling.style.opacity = "0";
        setTimeout(() => {
          sibling.style.opacity = "1";
          sibling.style.display = "";
        }, 100);
      }
    }
  }

  hideTooltip(ev) {
    const targetEl = ev.target;
    const sibling = targetEl.nextElementSibling;
    if (targetEl === ev.currentTarget && sibling) {
      targetEl.classList.remove("show-tooltip");
    }
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
PerformanceRow.init();
